const axiosPromise = import(/* webpackChunkName: "axios" */ 'axios')

import * as types from '../actionTypes'
import UrlUtil from "../../utils/urlUtil"
import {searchTodo} from "../todolist/actions"

const url = new UrlUtil('/api/payment')

const MINUTES_TO_WAIT = 3

export const startPayment = (paymentInfo) => {
  return async (dispatch, getState) => {
    dispatch({type: types.SHOW_ERROR_MESSAGE, payload: null})  // clear any existi error
    const ePayResult = await getNewPaymentRequest(paymentInfo)(dispatch, getState)
    if (ePayResult) {
      if (ePayResult.code !== "2000") {
        dispatch({type: types.SHOW_ERROR_MESSAGE, payload: ePayResult.message})
      } else {
        if (ePayResult.data) {
          paymentInfo.paymentReqNo = ePayResult.data.paymentReqNo  // to pass to SprintPay later
          paymentInfo.notes = ePayResult.data.notes                // to pass to SprintPay later
          dispatch({type: types.START_PAYMENT_SUCCESS, payload: ePayResult, paymentInfo: paymentInfo})
          if (paymentInfo.platform === 'PC') {
            const userProfile = getState()?.userProfile
            if (userProfile?.usePcPopup) {
              startPaymentPaycargoPopup(paymentInfo, userProfile?.env)
            } else {
              dispatch(showSeeYouLater(true))
              window.open(ePayResult.data.paycargoUrl, 'payCargo')
              dispatch(pollForPayCargoFeedback(ePayResult.data.transactionId))
            }
          }
          if (paymentInfo.platform === 'SP') {
            dispatch(pollForSprintPayFeedback(paymentInfo))
          }
        }
      }
    } else {
      dispatch({type: types.SHOW_ERROR_MESSAGE, payload: 'A network error occurred. Please try again.'})
    }
  }
}

const startPaymentPaycargoPopup = (paymentInfo, env) => {
  const paycargoCheckout = document.querySelector('paycargo-checkout')

  // remove any commas from the amount string and convert to a number
  const amountNumber = parseFloat(paymentInfo.amount.replace(/,/g, ""))
  let cntrNumsDisplay = paymentInfo.cntrData.map(cntr => cntr.cntrNum).join(', ')
  const overFlow = cntrNumsDisplay.length > 200
  const transaction =
    {
      index: 0,
      vendorId: 'PRD' === env ? 288506 : 278600,
      type: 'RTR',
      parent: paymentInfo.blNumber,
      bolLink: overFlow ? '' : cntrNumsDisplay,
      number: paymentInfo.paymentReqNo,
      total: amountNumber,
      customerRefNumber: paymentInfo.customerRef
    }
  if (overFlow) {
    transaction.notes = cntrNumsDisplay
  }
  const transactions = [transaction]
  paycargoCheckout.setAttribute('pc-transactions', JSON.stringify(transactions))
  paycargoCheckout.makeVisible(true)
}

export const getNewPaymentRequest = (paymentInfo) => {
  return async (dispatch) => {
    const now = new Date(Date.now())  // so it can be mocked
    // toISOString() shows now in UTC timezone, so need to adjust based on timezone offset
    const nowAdjusted = new Date(now - (now.getTimezoneOffset() * 60000))
    paymentInfo.paymentDueDate = nowAdjusted.toISOString().split("T")[0]
    dispatch({type: types.LOADING_STARTED})
    const axios = (await axiosPromise).default
    const result = await axios.post(url.makeUrl(['start']), paymentInfo)
    dispatch({type: types.LOADING_STOPPED})
    return result && result.data
  }
}

export const handlePayCargoPopupDone = (event) => {
  return async (dispatch) => {
    console.log('in handlePayCargoPopupDone', event)
    if (event.type === 'paymentResponse') {
      const result = event.detail?.data?.success?.approve?.[0]
      if (result) {
        const postBody = {
          paymentReqNo: result.number,
          transactionId: result.transactionId,
          totalAmount: result.totalAmount.toString(),
          approvalDateUtc: result.approvalDateUTC,
          payerCompanyName: result.payerName,
          payerEmail: result.userEmail,
          payerName: result.approverName
        }
        const axios = (await axiosPromise).default
        await axios.post(url.makeUrl(['complete']), postBody)
        dispatch({type: types.PAYMENT_CLEARED,
          payload: result.totalAmount.toLocaleString('en-US') + ' ' + result.currency})
      }
    }
  }
}

let pollTimer

export const pollForPayCargoFeedback = (payCargoTransId) => {
  return async (dispatch) => {
    const timeToStop = Date.now() + (MINUTES_TO_WAIT * 60000)
    pollTimer = setInterval(() => {
      const timeNow = Date.now()
      if (timeNow > timeToStop) {
        dispatch({
          type: types.SHOW_ERROR_MESSAGE,
          payload: 'We waited for ' + MINUTES_TO_WAIT
              + ' minutes but did not receive notification of your payment.'
        })
        clearInterval(pollTimer)
        dispatch(searchTodo())
      } else {
        dispatch(pollOnceForPayCargoFeedback(payCargoTransId))
      }
    }, 2000)
  }
}

export const pollOnceForPayCargoFeedback = (payCargoTransId) => {
  return async (dispatch) => {
    const axios = (await axiosPromise).default
    const result = await axios.get(url.makeUrl(['checkPaymentFeedback', payCargoTransId]))
    if (result.data !== false) {
      dispatch({type: types.PAYMENT_CLEARED, payload: result.data})
      clearInterval(pollTimer)
    }
  }
}

export const pollForSprintPayFeedback = (paymentInfo) => {
  return async (dispatch) => {
    pollTimer = setInterval(() => {
      dispatch(pollOnceForSprintPayFeedback(paymentInfo))
    }, 500)
  }
}

export const pollOnceForSprintPayFeedback = (paymentInfo) => {
  return async (dispatch) => {
    const sprintStatus = window.SPRINT_PAYMENT_STATUS
    const elementList = document.getElementsByClassName('with-sprintpay__modal')
    if (!elementList.length) {
      if (sprintStatus && sprintStatus.get().success) {
        dispatch({type: types.PAYMENT_CLEARED, payload: paymentInfo.amount})
      } else {
        dispatch({
          type: types.SHOW_ERROR_MESSAGE,
          payload: 'The SprintPay payment was cancelled.  To try again, click the "Pay Now with SprintPay" button.'
        })
        console.log('paymentInfo', paymentInfo)
        const axios = (await axiosPromise).default
        axios.get(
            url.makeUrl(['cancelSprintPay', paymentInfo.blNumber, paymentInfo.paymentReqNo]),
            paymentInfo)
      }
      clearInterval(pollTimer)
    }
  }
}

export const showSeeYouLater = (showOrHide) => {
  return (dispatch) => {
    if (!showOrHide) {
      clearInterval(pollTimer)
    }
    dispatch({type: types.SHOW_SEE_YOU_LATER, payload: showOrHide})
  }
}
